import dayjs from 'dayjs';
import { SearxngSearchOptions } from '../searxng';
import utc from 'dayjs/plugin/utc';
import relativeTime from 'dayjs/plugin/relativeTime';
import 'dayjs/locale/zh-cn';
import 'dayjs/locale/ko';
import 'dayjs/locale/en';
import 'dayjs/locale/zh-tw';
import 'dayjs/locale/ja';
import { LangType, loadLanguagePreference } from '../i18n/storage';
import { isArray } from 'lodash';

// import

dayjs.extend(utc);
dayjs.extend(relativeTime);

export const getSearchSearXNGTimeRange = (
  startTime?: string,
  diff: number = 0, // 默认差值为 0 小时
): NonNullable<SearxngSearchOptions['time_range']> | undefined => {
  if (!startTime) {
    return undefined;
  }
  const now = dayjs();
  const start = dayjs(startTime).add(diff, 'hour'); // 把 diff 小时算进来

  const diffInHours = now.diff(start, 'hour');

  if (diffInHours < 24 * 7) {
    return 'week';
  } else if (diffInHours < 24 * 30) {
    return 'month';
  } else if (diffInHours < 24 * 365) {
    return 'year';
  } else {
    return undefined;
  }
};

export function formatTimeAgo(
  time: Date | string | number,
  format: string = 'MMM DD, YYYY',
): string {
  const t = dayjs(time).valueOf();
  const now = dayjs(Date.now()).valueOf();
  const diff = now - t;

  const m = 60 * 1000;
  const h = 60 * m;
  const d = 24 * h;

  const lang = loadLanguagePreference() || 'en';

  // if (diff < m) return 'Just now';
  // if (diff < h) return `${Math.floor(diff / m)} min ago`;
  // if (diff < d) return `${Math.floor(diff / h)} h ago`;
  if (diff < 7 * d) {
    const text = dayjs().locale(lang.toLowerCase()).to(dayjs(t));
    return text === 'a day ago' ? '1 day ago' : text;
  }

  return formatDateTime(time, format);
}

export function formatDateTime(
  time?: Date | string | number | dayjs.Dayjs | null,
  format: string = 'MMM DD, YYYY',
): string {
  if (!time) return '-';
  const lang = loadLanguagePreference() || 'en';
  return dayjs(time).locale(lang.toLowerCase()).format(format);
}

export function isTimePoint(str?: string) {
  if (!str || typeof str !== 'string') return false;

  const matches = str.match(
    /(January|February|March|April|May|June|July|August|September|October|November|December)[\s\u00A0]+\d{1,2}/gi,
  );

  if (isArray(matches)) return true;

  return false;
}
